import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './LocalEvent.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Form from 'react-bootstrap/Form';
import { Link,useNavigate } from 'react-router-dom';
import {validatelocalevent} from '../../../Utils/validate';

const LocalEvent = () => {
    const navigate = useNavigate();

    const [inputs,setInputs] = useState({event_title:'',event_date:'',from_time:'',to_time:'',event_venue:'',event_detail:'',contact_detail:''});

    const [errors,setErrors] = useState({});

    useEffect(() => {
        document.title = `Local Event | Local Bells`;
        document.getElementById('bodywrap').className = 'neloceve';
    }, []);

  // State to toggle sidebar visibility
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

    const [images, setImages] = useState([]);

    // Handle files dropped or selected
    const handleFiles = (files) => {
        const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
        const newImages = imageFiles.map(file => ({
            file,
            url: URL.createObjectURL(file),
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    // Handle drag events
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = e.dataTransfer.files;
        handleFiles(files);
    };
    const handleDelete = (urlToRemove) => {
        setImages(prev => {
            const updated = prev.filter(img => img.url !== urlToRemove);
            URL.revokeObjectURL(urlToRemove); // Clean up memory
            return updated;
        });
    };
    const handleInputChangeimg = (e) => {
        handleFiles(e.target.files);
    };
    /* Start Value set */
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
    }
    /* End Value set */
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validatelocalevent(inputs,images);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
            navigate('/neighbour/local-dashboard');
        } 
    };    


    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />  
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={9} lg={8} xl={8} xxl={6}>

                                        <div className='white-box loceve-box'>
                                            
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>Local Event</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            <h6>Let neighbors know about public events in your neighborhood like Religious Festivals, Charity events, Blood donations, Political event. Campaigns, Music, Entertainment, Kids events</h6>
                                            <Form onSubmit={handleSubmit}>

                                                <div className=''>
                                                    {/* Dropzone */}
                                                    <div
                                                        onDrop={handleDrop}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDragEnter={(e) => e.preventDefault()}
                                                        className='gen-upload'

                                                    >
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={handleInputChangeimg}
                                                            id="fileInput"
                                                        />
                                                        <label htmlFor="fileInput">
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/uploadicn.webp'} className="img-fluid" alt="uploadicn" />
                                                            <div>
                                                                <h6>Upload event image</h6>
                                                                <h6><span className='fw-600'>420 X 270</span> px</h6>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    {errors.images && (<p className="text-danger">{errors.images}</p>)}
                                                    {/* Previews */}
                                                    <div className='gen-upload-preview'>
                                                        {images.map((img, index) => (
                                                            <div key={index} >
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                />
                                                                <button
                                                                    onClick={() => handleDelete(img.url)}
                                                                    type='button'
                                                                >
                                                                    &times;
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Event Title</Form.Label>
                                                    <Form.Control type="text" placeholder="Event Title" name="event_title" onChange={handleInputChange} value={inputs.event_title} />
                                                    {errors.event_title && (<p className="text-danger">{errors.event_title}</p>)}
                                                </Form.Group>   
                                                <Row>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className='d-none'>Event Venue</Form.Label>
                                                            <Form.Control   
                                                                placeholder="Event Date"
                                                                type={inputs.event_date ? 'date' : 'text'}                                                                
                                                                value={inputs.event_date}
                                                                onChange={handleInputChange}
                                                                onFocus={(e) => (e.target.type = 'date')}
                                                                onBlur={(e) => {
                                                                    if (!e.target.value) e.target.type = 'text';
                                                                }}
                                                                name="event_date"
                                                             />
                                                             {errors.event_date && (<p className="text-danger">{errors.event_date}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                </Row>                                             
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className='d-none'>From Time</Form.Label>
                                                            <Form.Control 
                                                                placeholder="From Time"
                                                                type={inputs.from_time ? 'time' : 'text'}                                                                
                                                                value={inputs.from_time}
                                                                onChange={handleInputChange}
                                                                onFocus={(e) => (e.target.type = 'time')}
                                                                onBlur={(e) => {
                                                                    if (!e.target.value) e.target.type = 'text';
                                                                }}
                                                                name="from_time"
                                                            />
                                                            {errors.from_time && (<p className="text-danger">{errors.from_time}</p>)}
                                                        </Form.Group>                                                       
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className='d-none'>To Time</Form.Label>
                                                            <Form.Control 
                                                                placeholder="To Time"
                                                                type={inputs.to_time ? 'time' : 'text'}                                                                
                                                                value={inputs.to_time}
                                                                onChange={handleInputChange}
                                                                onFocus={(e) => (e.target.type = 'time')}
                                                                onBlur={(e) => {
                                                                    if (!e.target.value) e.target.type = 'text';
                                                                }} 
                                                                name="to_time"                                                           
                                                            />
                                                            {errors.to_time && (<p className="text-danger">{errors.to_time}</p>)}
                                                        </Form.Group>                                                       
                                                    </Col>
                                                </Row>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Event Venue</Form.Label>
                                                    <Form.Control type="text" placeholder="Event Venue" name="event_venue" onChange={handleInputChange} value={inputs.event_venue} />
                                                    {errors.event_venue && (<p className="text-danger">{errors.event_venue}</p>)}
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Event Detail</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Event Detail' name="event_detail" onChange={handleInputChange} value={inputs.event_detail} />
                                                    {errors.event_detail && (<p className="text-danger">{errors.event_detail}</p>)}
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Contact Details</Form.Label>
                                                    <Form.Control type="text" placeholder="Contact details" name="contact_detail" onChange={handleInputChange} value={inputs.contact_detail} maxLength={15} />
                                                    {errors.contact_detail && (<p className="text-danger">{errors.contact_detail}</p>)}
                                                </Form.Group>
                                                <Button type="submit" className='blue-btn'>Post Event</Button>
                                            </Form>
                                        </div>

                                        <div className='red-note'>
                                            <h6>Terms and conditions: Users must follow respectful communication guidelines. Hate speech, harassment, and misinformation are prohibited, and may result in content removal or account suspension</h6>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default LocalEvent;


